export const API_URLS = {
  baseUrl: "https://api.anuncio360.com.br",
  users: "https://api.anuncio360.com.br/users",
  deleteusers: "https://api.anuncio360.com.br/users/byadmin",
  login: "https://api.anuncio360.com.br/admin/auth/login",
  role: "https://api.anuncio360.com.br/admins/profile",
  cadastro: "https://api.anuncio360.com.br/users",
  gerenciar: "https://api.anuncio360.com.br/admins",
  categorias: "https://api.anuncio360.com.br/categories",
  subcategorias: "https://api.anuncio360.com.br/subcategories",
  ads: "https://api.anuncio360.com.br/ads/byadmin",
  gerenciarAds: "https://api.anuncio360.com.br/ads/reasonStatus",
  planos: "https://api.anuncio360.com.br/plans",
  pagamentos: "https://api.anuncio360.com.br/payments/all",
  legal: "https://api.anuncio360.com.br/legal",
  admincities: "https://api.anuncio360.com.br/admin-cities",
  notifications: "https://api.anuncio360.com.br/notifications",
  sorteios: "https://api.anuncio360.com.br/draws",
  competition: "https://api.anuncio360.com.br/admin/scale-competitions",
};
